<template>
	<app-page-content>
		<app-title>Nuevo Visitante</app-title>
		<v-card>
			<v-img :src="$route.query.p"></v-img>
			<v-card-title primary-title>
				<div>
					<h3 class="headline mb-0">{{ $route.query.n }}</h3>
				</div>
			</v-card-title>
			<v-card-actions>
				<v-btn flat color="red" @click="sendResponse(0)">Denegar</v-btn>
				<v-btn flat color="green" @click="sendResponse(1)"
					>Aprobar</v-btn
				>
			</v-card-actions>
		</v-card>
	</app-page-content>
</template>
<script>
import axios from "axios";
export default {
	data: () => ({}),
	computed: {},
	methods: {
		async sendResponse(val) {
			const { data } = await axios.get(
				`https://bitacorapp.com/access-control/authorization/response-app?authorizationId=${this.$route.query.aid}&responseById=${this.user.id}&response=${val}`
			);
			if (data.status) {
				toastr.success("Respuesta notificada");
				this.$router.push({ name: "home" });
			} else {
				toastr.error(data.msg);
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/pages/Visits/ViewVisitor.vue